import { AsyncPipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AssetsService, IconName } from '@sc/data-access-assets';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sc-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatIconModule, AsyncPipe],
  styleUrls: ['./icon.component.scss'],
  template: `
    <mat-icon
      #customIcon
      [svgIcon]="getName() | async"
      [inline]="inline"
      [class.forced-initial-color]="forceInitialColor"
    ></mat-icon>
  `,
  host: {
    'aria-hidden': 'true',
    tabindex: '-1',
  },
})
export class IconComponent implements AfterViewInit {
  @Input() name: IconName;
  @Input() specificName?: string;
  @Input() inline = false;
  @Input() forceInitialColor = false;
  @ViewChild('customIcon', { static: false, read: ElementRef })
  customIcon: ElementRef<HTMLElement>;

  constructor(
    private readonly assetsService: AssetsService,
    private readonly renderer: Renderer2,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.manageA11yAttributes();
  }

  getName(): Observable<IconName> {
    return this.assetsService.getImagesMapping().pipe(
      map((iconsMap) => {
        let nameToReturn: IconName = iconsMap.specificMap[this.specificName];
        if (!!this.specificName && !!nameToReturn) {
          return nameToReturn;
        }
        nameToReturn = iconsMap.globalMap?.[this.name] ?? this.name;
        return nameToReturn;
      })
    );
  }

  manageA11yAttributes(): void {
    this.renderer.removeAttribute(this.customIcon.nativeElement, 'role');
    this.renderer.setAttribute(
      this.customIcon.nativeElement,
      'focusable',
      'false'
    );
    this.renderer.removeAttribute(
      this.customIcon.nativeElement.parentNode,
      'aria-describedby'
    );
    this.changeDetectorRef.detectChanges();
  }
}
